<template>
  <div id="wrapper">
    <!-- Sidebar -->
    <SideBarMenu />
    <!-- /#sidebar-wrapper -->
    <HeaderBarMenu v-bind:title="pageTitle" />
    <!-- Page Content -->
    <div id="page-content-wrapper">
      <div class="container-fluid">
        <div class="row filter-row row-background-color" style="padding: 10px">
          <div class="col-sm mobile-small-bottom">
            <div class="search">
              <i class="fa fa-search"></i>
              <input type="text" class="form-control" placeholder="Search Officer..." v-model="searchText"
                v-on:change="calculatefilterReports" />
              <button class="btn btn-primary" v-on:click="calculatefilterReports">
                <img src="../assets/search.svg" class="icons-search" />
              </button>
            </div>
          </div>
          <div class="col-sm mobile-small-bottom">
            <SelectorShip v-bind:shipInventorylist="options" ref="emsshipselect" @changedSelect="changeShip" />
          </div>

          <div class="col-sm mobile-small-bottom">
            <VueCtkDateTimePicker label="Select date and time" format="YYYY-MM-DD HH:mm" v-model="dateValueFrom"
              dark="true" id="1" />
          </div>
          <div class="col-sm mobile-small-bottom">
            <VueCtkDateTimePicker label="Select date and time" format="YYYY-MM-DD HH:mm" v-model="dateValueTo"
              dark="true" id="2" />
          </div>




          <!-- create user -->
          <vue-final-modal v-model="createReport" classes="modal-container" content-class="modal-content">
            <button class="modal__close" v-on:click="cancelFormNewReport">
              <mdi-close>
                <img src="../assets/modal-close-button.svg" />
              </mdi-close>
            </button>
            <div class="modal__content">
              <div class="row" style="margin-top: 25px">
                <div class="col-12" style="text-align: left; padding-left: 25px">
                  <h3>Create Report</h3>
                </div>
              </div>
              <div class="row" style="margin-top: 25px">
                <div class="col-1">
                  <img src="../assets/country.svg" class="icons-user" />
                </div>
                <div class="col-11">
                  <SelectorCountry v-bind:countryInventorylist="countries" ref="emscountriesselect"
                    @changedSelect="changeCountry" />
                  <!-- <input type="text" class="form-control" v-model="newReport.country"
                      placeholder="Full designation of the Country..." /> -->
                </div>
              </div>
              <div class="row" style="margin-top: 25px">
                <div class="col-1">
                  <img src="../assets/location.svg" class="icons-user" />
                </div>
                <div class="col-11">
                  <SelectorCity v-bind:cityInventorylist="cities" ref="emscitiesselect" @changedSelect="changeCity" />
                  <!-- <input type="text" class="form-control" v-model="newReport.issuedAt" placeholder="Issued at..." /> -->
                </div>
              </div>

              <!-- <div class="row" style="margin-top: 25px">
                  <div class="col-1">
                    <img src="../assets/sea.svg" class="icons-user" />
                  </div>
                  <div class="col-11">
                    <input type="text" class="form-control" v-model="newReport.port" placeholder="Enter port of registry" />
                  </div>
                </div> -->
              <!-- <div class="row" style="margin-top: 25px">
                  <div class="col-1">
                    <img src="../assets/date.svg" class="icons-user" />
                  </div> -->
              <!-- <div class="col-11">
                    <div class="col-sm">
                      <VueCtkDateTimePicker label="Is Valid until..." format="YYYY-MM-DD HH:mm"
                        v-model="newReport.validDate" dark="true" id="3" />
                    </div>
                  </div> 
                </div>-->

              <div class="row" style="margin-top: 25px">
                <div class="col-1">
                  <img src="../assets/username.svg" class="icons-user" />
                </div>
                <div class="col-11">
                  <input type="text" class="form-control" v-model="newReport.officer" placeholder="Officer" readonly
                    style="background-color: #536872 !important; color: white !important;" />
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <hr />
                </div>
              </div>



              <div style="margin-top: 25px">

                <!-- <button type="button"  class="btn btn-primary" style="float: right; width: 150px" @click="getGeolocation">
    Get Geolocation
  </button> -->



                <button type="button" class="btn btn-primary" style="float: right; width: 150px"
                  v-on:click="submitFormNewReport">
                  Create New Report
                </button>

                <button type="button" class="btn btn-danger" style="float: right; width: 120px; margin-right: 25px"
                  v-on:click="cancelFormNewReport">
                  Cancel
                </button>

                <button type="button" class="btn btn-info"
                  style="float: right; width: 150px;margin-right: 25px; color:white" v-on:click="getGeolocation">
                  Get Geolocation Data
                </button>
              </div>
            </div>
          </vue-final-modal>

          <vue-final-modal v-model="showModal" classes="modal-container" content-class="modal-content">
            <button class="modal__close" @click="showModal = false">
              <mdi-close>
                <img src="../assets/modal-close-button.svg" />
              </mdi-close>
            </button>
            <span class="modal__title">{{ this.modalTitle }}</span>
            <div class="modal__content">
              <p v-for="item in this.errorList" :key="item">- {{ item }}</p>
            </div>
          </vue-final-modal>

          <vue-final-modal v-model="deleteReport" classes="modal-container" content-class="modal-content">
            <button class="modal__close" @click="deleteReport = false">
              <mdi-close>
                <img src="../assets/modal-close-button.svg" />
              </mdi-close>
            </button>
            <span class="modal__title">Are you sure you want to delete this report?</span>
            <div class="modal__content">
              <div style="margin-top: 25px">
                Confirm that you will delete this report with id: {{ reportTobedeleted.Id }} by {{
      reportTobedeleted.IssueBy }}
                <br /><br />
                <button type="button" class="btn btn-primary" style="float: right; width: 120px"
                  v-on:click="confirmDeleteNewReport">
                  Delete Report
                </button>

                <button type="button" class="btn btn-danger" style="float: right; width: 120px; margin-right: 25px"
                  v-on:click="cancelDeleteNewReport">
                  Cancel
                </button>
              </div>
            </div>
          </vue-final-modal>
          <div class="col-sm">
            <button type="button" class="btn btn-primary w-100" @click="applytoCreateReport">
              Create Report
            </button>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <ReportsTable v-bind:reports="this.filterReports" @changedSelect="downloadTableRow"
              @deletedSelect="deletedTableRow" />

          </div>
        </div>
      </div>
    </div>
    <!-- /#page-content-wrapper -->
  </div>
  <!-- /#wrapper -->
</template>

<script>
import Popper from "vue3-popper";
import MonitorService from "../services/monitor.service";
import ShipService from "../services/ship.service";
import UserService from "../services/user.service";
import ReportService from "../services/report.service"
import SideBarMenu from "../components/SideBarMenu.vue";
import HeaderBarMenu from "../components/HeaderBarMenu.vue";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import ReportsTable from "../components/ReportsTable.vue";
import TokenService from "../services/token.service";
import SelectorShip from "../components/SelectorShip";
import SelectorCountry from "../components/SelectorCountry";
import SelectorCity from "../components/SelectorCity";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import UtilityService from "../services/utility.service";
import GeolocationService from "../services/geolocation.service";
// import CacheService from "@/services/cache.service";
// import { runInThisContext } from "vm";
export default {
  name: "Reports",
  components: {
    SideBarMenu,
    HeaderBarMenu,
    Popper,
    SelectorCity,
    SelectorShip,
    VueCtkDateTimePicker,
    ReportsTable,
    SelectorCountry,
    GeolocationService
    // CacheService
  },
  data() {
    return {
      pageTitle: "Reports",
      searchText: "",
      options: [],
      createReport: false,
      dateValueFrom: null,
      dateValueTo: null,
      errorList: [],
      showModal: false,
      selectedShipID: 0,
      selectedCountry: {},
      selectedCity: {},
      shipReportData: {},
      reportTobedeleted: {},
      deleteReport: false,
      reports: {},
      filterReports: {},
      newReport: {
        country: '',
        officer: "",
        // port: "",
        issuedAt: "",
        // validDate: null,
      },
      countries: [],
      cities: [
      ],
      // searchModeCoords: false,
      // cachedShipId:0
    };
  },
  watch: {
    dateValueFrom() {
      this.calculatefilterReports();
    },
    dateValueTo() {
      this.calculatefilterReports();
    }
  },
  computed: {
    filterReportsList() {
    },


  },
  mounted() {
    this.getOfficer();
    this.getShips();
    this.getCountries();
    this.dateValueFrom = UtilityService.fromDatePastInit(0);
    this.dateValueTo = UtilityService.toDateInit();
    setTimeout(() => this.loadData(), 2000);


  },
  methods: {
    getOfficer() {
      if (sessionStorage.getItem("user") == null) {
        this.newReport.officer = "Officer";
      }
      else {
        this.newReport.officer = TokenService.getUser().username;
      }

    },
    getGeolocation() {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const coords = position.coords;
            this.getCountriesByCoords(coords);
            // You can now use these coordinates to do something more, 
            // like fetching weather data for this location or showing it on a map.
          },
          (error) => {
            console.error("Error getting geolocation: ", error);
            // Handle errors here, such as showing an alert to the user.
          }
        );
      } else {
        console.error("Geolocation is not supported by this browser.");
        // Inform the user that geolocation is not supported.
      }
    },
    //calculare report after getting data from the api
    calculatefilterReports() {

      let tempFilterReports = [];
      let tempResultFilterReports = [];
      let tempResultFilterReportsTo = [];
      let tempResultFilterReportsShip = [];
      let tempResultFilterReportsText = [];

      for (let i = 0; i < this.reports.length; i++) {
        tempFilterReports.push(this.reports[i])
      }


      if (this.dateValueFrom != null) {

        for (let i = 0; i < tempFilterReports.length; i++) {

          if (Date.parse(tempFilterReports[i].DateFrom) < Date.parse(this.dateValueFrom)) {
          } else {
            tempResultFilterReports.push(tempFilterReports[i]);
          }
        }
      }



      if (this.dateValueTo != null) {

        for (let i = 0; i < tempResultFilterReports.length; i++) {
          if (Date.parse(tempResultFilterReports[i].DateTo) > Date.parse(this.dateValueTo)) {
          } else {
            tempResultFilterReportsTo.push(tempResultFilterReports[i]);
          }
        }
      } else {
        tempResultFilterReportsTo = tempResultFilterReports;
      }


      if (this.selectedShipID != 0) {
        for (let i = 0; i < tempResultFilterReportsTo.length; i++) {
          if (tempResultFilterReportsTo[i].ShipId == this.selectedShipID) {
            tempResultFilterReportsShip.push(tempResultFilterReportsTo[i]);
          } else {
          }
        }
      } else {
        tempResultFilterReportsShip = tempResultFilterReportsTo;
      }


      let filterSearchText = this.searchText.toLowerCase();


      if (filterSearchText.length > 0) {
        for (let i = 0; i < tempResultFilterReportsShip.length; i++) {
          let name = tempResultFilterReportsShip[i].IssueBy.toLowerCase();
          if (name.includes(filterSearchText)) {
            tempResultFilterReportsText.push(tempResultFilterReportsShip[i]);
          } else {

          }
        }

      } else {
        tempResultFilterReportsText = tempResultFilterReportsShip;
      }

      this.filterReports = tempResultFilterReportsText;


    },
    async loadData() {
      let promise = new Promise((resolve, reject) => {
        let shipResult = this.getShips();
        resolve("done!")
      });
      let result = await promise;
      this.getReports();
    },
    //get report data
    getReports: function () {
      ReportService.getReports().then(
        (response) => {
          this.reports = response.data;
          this.calculatefilterReports();



          for (let i = 0; i < this.reports.length; i++) {
            if (this.options.length > 0) {
              for (let j = 0; j < this.options.length; j++) {
                if (this.reports[i].ShipId == this.options[j].shipId) {
                  this.reports[i].ShipName = this.options[j].shipName;
                }
              }
            }


          }
        },
        (error) => {
          this.showAPIError("Get Monitor Data", error);
          if (error.response && error.response.status === 401) {
            this.$store.dispatch("logout");
          }
        }
      );
    },
    //create new report
    createNewReport: function (report) {
      this.createReport = false;
      ReportService.createNewReport(report).then(
        (response) => {
          this.getShips();
          this.getReports();
        },
        (error) => {
          this.showAPIError("Create New Report", error);
          if (error.response && error.response.status === 401) {
            this.$store.dispatch("logout");
          }
        }
      );
    },

    //hadle and validate new report creation before proceed
    submitFormNewReport: function () {

      this.errorList = [];



      if (this.newReport.country.length < 1) {
        this.errorList.push("You have to select a country");
      }


      if (this.newReport.officer.length < 3) {
        this.errorList.push("Officer name should have at least 3 characters");
      }

      if (this.newReport.issuedAt.length < 1) {
        this.errorList.push("You have to select a city");
      }

      if (this.errorList.length > 0) {
        this.modalTitle = "Error";
        this.showModal = true;
      } else {
        let reportToBesubmitted = {};
        reportToBesubmitted.ShipId = this.selectedShipID;
        reportToBesubmitted.ReportFrom = this.dateValueFrom;
        reportToBesubmitted.ReportTo = this.dateValueTo;
        reportToBesubmitted.IssueBy = this.newReport.officer;
        reportToBesubmitted.IssueAt = this.newReport.issuedAt;


        reportToBesubmitted.Country = this.newReport.country;
        this.createNewReport(reportToBesubmitted);
      }
    },
    //delete report
    confirmDeleteNewReport: function () {
      this.deleteReport = false;
      ReportService.deleteReport(this.reportTobedeleted.Id).then(
        (response) => {
          this.loadData();
        },
        (error) => {
          this.showAPIError("Delete New Report", error);
          if (error.response && error.response.status === 401) {
            this.$store.dispatch("logout");
          }
        }
      );
    },
    //cancel a delete report action
    cancelDeleteNewReport: function () {
      this.deleteReport = false;
      this.reportTobedeleted = {};
    },
    cancelFormNewReport: function () {
      this.cleanTempReport();
      this.createReport = false;
      this.$refs.emscountriesselect.value = this.countries[0];
      this.$refs.emscitiesselect.value = this.cities[0];
    },
    //clean temporary  report - a report created locally before sumitted to api to be saved to database
    cleanTempReport: function () {
      this.newReport.country = "";
      // this.newReport.officer = "";
      // this.newReport.port = "";
      this.newReport.issuedAt = ""
      // this.newReport.validDate = null;
      this.selectedCountry = {};
      this.selectedCity = {};
    },

    //get ships data availale to user
    getShipsData() {
      MonitorService.getSingleShipMonitorData(
        this.dateValueFrom,
        this.dateValueTo,
        this.selectedShipID
      ).then(
        (response) => {
          this.shipReportData = response.data;
          this.createReport = true;
        },
        (error) => {
          this.showAPIError("Get Monitor Data", error);
          if (error.response && error.response.status === 401) {
            this.$store.dispatch("logout");
          }
        }
      );
    },
    //validate creation of report
    applytoCreateReport: async function () {
      this.errorList = [];

      if (this.dateValueFrom == null || this.dateValueTo == null) {
        this.errorList.push("Date fields can not be NULL");
      }

      if (this.selectedShipID < 1 || this.selectedShipID == null) {
        this.errorList.push("You have to select a Vessel");
      }

      let dateToDateFinal = new Date(this.dateValueTo);
      let dateFromDateFinal = new Date(this.dateValueFrom);


      if (dateToDateFinal.getFullYear() !== dateFromDateFinal.getFullYear()) {
        this.errorList.push(
          "Both dates are not in the same year.CII requires dates to be in the same year.\n"
        );

      }

      if (this.errorList.length > 0) {
        this.modalTitle = "Error";
        this.showModal = true;
        return;
      }
      this.getShipsData();


    },
    //download report
    downloadTableRow: function (value) {



      MonitorService.getSingleShipMonitorData(
        value.DateFrom,
        value.DateTo,
        value.ShipId
      ).then(
        (response) => {
          value.CII = response.data.Report.AttainedCII;
          value.RequiredCII = response.data.Report.RequiredCII;
          value.DeadWeight = response.data.Report.DeadWeight;
          value.ShipCode = response.data.Report.ShipCode;
          value.IMO = response.data.Report.IMO;
          value.shipType = "Cruise passenger ship having non-conventional propulsion";
          sessionStorage.setItem("documentdetails", JSON.stringify(value));
          window.open("/#/ReportPdf", "_blank");

        },
        (error) => {
          this.showAPIError("Get Decomposition Data", error);
          if (error.response && error.response.status === 401) {
            this.$store.dispatch("logout");
          }
        }
      );



    },
    //get event of deletetion
    deletedTableRow: function (value) {
      this.deleteReport = true;
      this.reportTobedeleted = value;
    },
    //get the event of a selection of a report
    selectedTableRow: function (value) {
      this.cleanTempUser();
      this.newUser.idForEdit = value.Id;
      this.newUser.name = value.Name;
      this.newUser.email = value.Email;
      if (value.RoleId > 0) {
        this.newUser.RoleId = true;
      } else {
        this.newUser.RoleId = false;
      }

      for (let i = 0; i < this.shipAccesses.length; i++) {
        for (let j = 0; j < value.ShipAccesses.length; j++) {
          if (this.shipAccesses[i].ShipId == value.ShipAccesses[j].ShipId) {
            this.shipAccesses[i].Selected = true;
          }
        }
      }

      this.editUser = true;
    },
    showAPIError: function (title, value) {
      this.modalTitle = "Error: " + title;
      this.errorList = [];
      this.errorList.push(value);
      this.showModal = true;
    },
    //get ships availale to user
    getShips: function (shipValue) {
      let preselected = 0;
      ShipService.getShipsAuth().then(
        (response) => {
          let arrayShipsTemp = response.data.ShipsBasicData;
          let startedShipsArray = [];
          let selectedShips = [];

          //All Vessels
          let shipTemp = {};
          shipTemp.shipId = 0;
          shipTemp.shipName = "Select a Vessel";
          selectedShips.push(shipTemp);

          for (let i = 0; i < arrayShipsTemp.length; i++) {
            let shipTemp = {};
            shipTemp.shipId = arrayShipsTemp[i].ShipId;
            shipTemp.shipName = arrayShipsTemp[i].ShipName;
            selectedShips.push(shipTemp);
            if (shipValue == shipTemp.shipId) {
              preselected = i + 1;
            }
          }

          this.options = selectedShips;


          this.changeShip(selectedShips[preselected]);
          this.$refs.emsshipselect.value = selectedShips[preselected];



          if (this.preselectedShip > 0) {
            this.submitForm();
          }
        },
        (error) => {
          this.showAPIError("Get Ships", error);
          if (error.response && error.response.status === 401) {
            this.$store.dispatch("logout");
          }
        }
      );
    },



    //get countries available
    getCountries: function () {
      let preselected = 0;
      GeolocationService.getCountries().then(
        (response) => {

          // this.searchModeCoords=false;
          let arrayCountriesTemp = response.data;
          let startedCountriesArray = [];
          let selectedCountries = [];

          //All Countries
          let countryTemp = {};
          countryTemp.countryId = 0;
          countryTemp.countryName = "Select a Country";
          countryTemp.latitude = 0;
          countryTemp.longitude = 0;
          selectedCountries.push(countryTemp);

          for (let i = 0; i < arrayCountriesTemp.length; i++) {
            countryTemp = {};
            countryTemp.countryId = arrayCountriesTemp[i].Id;
            countryTemp.countryName = arrayCountriesTemp[i].Name;
            countryTemp.latitude = arrayCountriesTemp[i].Latitude;
            countryTemp.longitude = arrayCountriesTemp[i].Longitude;
            selectedCountries.push(countryTemp);
          }

          this.countries = selectedCountries;

        },

        (error) => {
          this.showAPIError("Get Countries", error);
          if (error.response && error.response.status === 401) {
            this.$store.dispatch("logout");
          }
        }
      );
    },


    //get countries available
    getCountriesByCoords: function (coords) {
      GeolocationService.getCountriesByCoords(coords).then(
        (response) => {
          // this.searchModeCoords=true;
          let arrayCountriesTemp = response.data;
          let startedCountriesArray = [];
          let selectedCountries = [];
          let preselected = 0;
          //All Countries
          let countryTemp = {};
          countryTemp.countryId = 0;
          countryTemp.countryName = "Select a Country";
          selectedCountries.push(countryTemp);

          for (let i = 0; i < arrayCountriesTemp.length; i++) {
            countryTemp = {};
            countryTemp.countryId = arrayCountriesTemp[i].Id;
            countryTemp.countryName = arrayCountriesTemp[i].Name;
            selectedCountries.push(countryTemp);
            // if (shipValue == shipTemp.shipId) {
            preselected = i + 1;
            // }
          }

          this.countries = selectedCountries;

          // this.changeCountry(selectedCountries[0]);
          this.$refs.emscountriesselect.value = selectedCountries[1];
          this.newReport.country = selectedCountries[1].countryName;
          this.getCitiesByCountryAndCoords(selectedCountries[1].countryId, coords);
        },

        (error) => {
          this.showAPIError("Get Countries", error);
          if (error.response && error.response.status === 401) {
            this.$store.dispatch("logout");
          }
        }
      );
    },



    //get Cities available
    getCities: function (countryData) {
      let preselected = 0;
      GeolocationService.getCitiesByCountry(countryData).then(
        (response) => {

          let arrayCitiesTemp = response.data;
          let startedCitiesArray = [];
          let selectedCities = [];

          //All Cities
          let cityTemp = {};
          cityTemp.cityId = 0;
          cityTemp.cityName = "Select a City";
          selectedCities.push(cityTemp);

          for (let i = 0; i < arrayCitiesTemp.length; i++) {
            cityTemp = {};
            cityTemp.cityId = arrayCitiesTemp[i].Id;
            cityTemp.cityName = arrayCitiesTemp[i].Name;
            selectedCities.push(cityTemp);
          }

          this.cities = selectedCities;

          // this.changeShip(selectedShips[preselected]);
          this.$refs.emscitiesselect.value = selectedCities[1];
          this.newReport.issuedAt = selectedCities[1].cityName;

        },

        (error) => {
          this.showAPIError("Get Countries", error);
          if (error.response && error.response.status === 401) {
            this.$store.dispatch("logout");
          }
        }
      );
    },



    //get Cities and Coords available
    getCitiesByCountryAndCoords: function (country, coords) {
      let preselected = 0;
      GeolocationService.getCitiesByCountryAndCoords(country, coords.latitude, coords.longitude).then(
        (response) => {

          let arrayCitiesTemp = response.data;
          let startedCitiesArray = [];
          let selectedCities = [];

          //All Cities
          let cityTemp = {};
          cityTemp.cityId = 0;
          cityTemp.cityName = "Select a City";
          selectedCities.push(cityTemp);

          for (let i = 0; i < arrayCitiesTemp.length; i++) {
            cityTemp = {};
            cityTemp.cityId = arrayCitiesTemp[i].Id;
            cityTemp.cityName = arrayCitiesTemp[i].Name;
            selectedCities.push(cityTemp);
          }

          this.cities = selectedCities;

          // this.changeShip(selectedShips[preselected]);
          this.$refs.emscitiesselect.value = selectedCities[1];
          this.newReport.issuedAt = selectedCities[1].cityName;

        },

        (error) => {
          this.showAPIError("Get Countries", error);
          if (error.response && error.response.status === 401) {
            this.$store.dispatch("logout");
          }
        }
      );
    },


    //change ship selection
    changeShip: function (value) {
      if ((this.selectedShipID = null)) {
        this.selectedShipID = 0;
      } else {
        this.selectedShipID = value.shipId;
      }
      this.calculatefilterReports();
    },

    //change country selection
    changeCountry: function (value) {
      this.selectedCountry = value;
      this.selectedCity = {};
      this.newReport.country = value.countryName;

      this.getCities(value.countryId);

    },


    //change city selection
    changeCity: function (value) {
      // alert("change city")
      this.selectedCity = value;
      this.newReport.issuedAt = value.cityName;
    },
  },
};
</script>

<style scoped>
input {
  background-color: #171b25 !important;
  color: #fff !important;
}



.search {
  position: relative;
  box-shadow: 0 0 40px rgba(51, 51, 51, 0.1);
  background-color: #171b25;
}

.search input {
  height: 40px;
  text-indent: 25px;
  border: 1px solid #d6d4d4;
  color: white;
  background-color: #171b25 !important;
}

.search input:focus {
  box-shadow: none;
  border: 1px solid #d6d4d4;
}

.search .fa-search {
  position: absolute;
  top: 20px;
  left: 16px;
}

.search button {
  position: absolute;
  top: 5px;
  right: 5px;
  height: 30px;
  width: 60px;
  /* background: blue; */
}

::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

::v-deep .modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  /* background: #fff; */
  width: 50%;
  border-color: #2d3748;
  background-color: #1a202c;
}

@media only screen and (max-width: 700px) {
  ::v-deep .modal-content {
    width: 80%;
  }
}

.modal__title {
  margin: 0 2rem 0 0;
  font-size: 1.5rem;
  font-weight: 700;
}

.modal__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  background-color: #1b202c;
  border-color: #2d333d;
  border-style: solid;
}

.dark-mode div::v-deep .modal-content {
  border-color: #2d3748;
  background-color: #1a202c;
}

.switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 18px;
  margin-top: 2px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 4px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked+.slider {
  background-color: #2196f3;
}

input:focus+.slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked+.slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>